import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "../hooks/use-session.js";
import { PageSkeleton } from "../components/skeleton.js";

/**
 * Wraps protected routes. Redirects to /sign-in when no session exists.
 * Shows a loading state while the session check is in flight.
 * Preserves the intended destination in location state for post-login redirect.
 */
export function ProtectedRoute() {
  const { isLoading, isAuthenticated } = useSession();
  const location = useLocation();

  if (isLoading) {
    return <PageSkeleton />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/sign-in" state={{ returnTo: location.pathname }} replace />
    );
  }

  return <Outlet />;
}
